import useQueryParam from './util/useQueryParam';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  // Link
} from "react-router-dom";

import Calc from './Calc';
import ContactForm from './components/ContactForm';

function App() {
  const [bedCount] = useQueryParam('b', 10);
  const [padsPerWeek] = useQueryParam('w', 3);
  const [costPerPad] = useQueryParam('c', 14);
  const [hourlyStaffCost] = useQueryParam('s', 30);
  const [hourlyStaffCostUK] = useQueryParam('s', 10);
  const [minutesSaved] = useQueryParam('m', 10);

  return (
    <div className="p-2 sm:p-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="p-6 font-raleway font-semibold text-lg sm:text-2xl text-center">
          STEALTH<sup>&reg;</sup> Pad Savings Calculator
        </h1>
        <div className="border rounded-3xl shadow-md bg-white overflow-hidden">
          <Router>
            <Switch>
              <Route path="/usa">
                <Calc
                  bedCount={bedCount}
                  padsPerWeek={padsPerWeek}
                  costPerPad={costPerPad}
                  hourlyStaffCost={hourlyStaffCost}
                  minutesSaved={minutesSaved}
                  currency="USD"
                />
              </Route>
              <Route path="/uk">
                <Calc
                  bedCount={bedCount}
                  padsPerWeek={padsPerWeek}
                  costPerPad={costPerPad}
                  hourlyStaffCost={hourlyStaffCostUK}
                  minutesSaved={minutesSaved}
                  currency="GBP"
                />
              </Route>
              <Route path="/">
                <Calc
                  bedCount={bedCount}
                  padsPerWeek={padsPerWeek}
                  costPerPad={costPerPad}
                  hourlyStaffCost={hourlyStaffCost}
                  minutesSaved={minutesSaved}
                  currency="USD"
                />
              </Route>
            </Switch>
          </Router>
        </div>

        <div className=" mt-8 border rounded-3xl shadow-md bg-white overflow-hidden">
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default App;
